import { PORTFOLIO_ADMIN_CONSTANTS as C } from '../../_Shared/_MODULES/PortfolioAdminApi';
export const BLOG_ADMIN_API = { LIST: C.BLOG_LIST, SAVE: C.BLOG_SAVE, REMOVE: C.BLOG_REMOVE };
